import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../utils/apiConfig/apiRoutes";
import { apiPost } from "../../utils/apiConfig/apiService";
import { startCapitalize } from "../../utils/commonfunction";
import { routesName } from "../../routes/routesName";

export const analyticsDataToDataBase = createAsyncThunk(
  "analytics",
  async (data = {}, { getState = () => null, dispatch = () => null }) => {
    try {
      const state = getState();
      let windowPath = window.location.pathname;

      // windowPath = windowPath.replace(
      //   routesName.EXITING_PATIENT_FIND_APPOINTMENT,
      //   routesName.FIND_APPOINTMENT
      // );
      const utm = state?.Patientdetails?.utm;
      const isSendedPayload = state?.Patientdetails?.isPassedPayLoad;
      const sessionId = state?.Patientdetails?.sessionId;
      const clientId = state?.Patientdetails?.rulesConfig?.[0]?.clientid;
      const locationId = state?.servicetype?.location?.LocationId;
      const appointmentTypeId =
        state?.servicetype?.servicetype?.appointmentTypeId;
      let providerId = state?.Patientdetails?.selectedProvider?.providerId;
      const isExistingPatient = state?.Patientdetails?.isExistingPatient;
      if (
        windowPath.includes(routesName.IDENTITY) ||
        windowPath.includes(routesName.LANDING)
      ) {
        providerId = undefined;
      }

      const {
        eventLabel = undefined,
        pageName: page = "",
        isAptBooked = undefined,
        rwgToken,
        cancel = undefined,
        newPath = windowPath,
        ...others
      } = data;

      let pagePath = newPath.split("/");
      let lastPath = pagePath?.[pagePath?.length - 1];
      pagePath = newPath.replace(lastPath, page);

      const pageName = startCapitalize(page) || undefined;
      const mergeData = {
        sessionId,
        clientId,
        pagePath,
        pageName,
        eventLabel,
        locationId,
        appointmentTypeId,
        clickPagePath: newPath,
        clickPageName: startCapitalize(lastPath) || undefined,
        providerId,
        eventDetails: others,
        isExistingPatient:
          isExistingPatient == null ? undefined : isExistingPatient,
        googleSessionDetails: {
          utmSource: utm?.utm_source || undefined,
          utmMedium: utm?.utm_medium || undefined,
          utmCampaign: utm?.utm_campaign || "website",
          utmTerm: utm?.utm_term || undefined,
          rwgToken,
        },
        utm_source: utm?.utm_source || undefined,
        utm_medium: utm?.utm_medium || undefined,
        utm_campaign: utm?.utm_campaign || undefined,
        utm_term: utm?.utm_term || undefined,
        isAptBooked,
        utmCampaign: utm?.utm_campaign || "website",
        rwgToken,
      };
      if (isSendedPayload) {
        delete mergeData.googleSessionDetails;
      }

      await apiPost(API_ROUTES?.POST_ANALYTICS, mergeData, cancel);
      // if (utm?.utm_source && !isSendedPayload) {
      //   dispatch(updatePassedPayLoad(true));
      // }
      if (!isSendedPayload) {
        dispatch(updatePassedPayLoad(true));
      }
    } catch (error) {
      console.log(error);
    }
  }
);

const patientSlice = createSlice({
  name: "patientdetails",
  initialState: {
    patients: [],
    patientdetail: [],
    selectedProvider: null,
    isExistingPatient: null,
    insurancePolicy: null,
    selectedTime: null,
    rulesConfig: [],
    sessionId: null,
    contentValue: 64,
    utm: null,
    isPassedPayLoad: false,
    pageLoader: true,
  },
  reducers: {
    patientValue: (state, action) => {
      state.patients = action.payload;
    },
    updateRulesConfig: (state, action) => {
      state.rulesConfig = action.payload;
    },
    removepatientValue: (state, action) => {
      state.patients = [];
      state.patientdetail = [];
      state.selectedProvider = null;
      state.isExistingPatient = false;
      state.insurancePolicy = null;
      state.selectedTime = null;
      // state.rulesConfig = [];
    },
    patientdetailsValue: (state, action) => {
      state.patientdetail = action.payload;
    },
    updateSelectedProvider: (state, action) => {
      state.selectedProvider = action.payload;
    },
    updateselectedTime: (state, action) => {
      state.selectedTime = action.payload;
    },
    updateIsExistingPatient: (state, action) => {
      state.isExistingPatient = action.payload;
    },
    updateInsurancePolicy: (state, action) => {
      state.insurancePolicy = action.payload;
    },
    updateSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    updateContentValue: (state, action) => {
      state.contentValue = action.payload;
    },
    updateUTM: (state, action) => {
      state.utm = action.payload;
    },
    updatePassedPayLoad: (state, action) => {
      state.isPassedPayLoad = action.payload;
    },
    updatePageLoader: (state, action) => {
      state.pageLoader = action.payload;
    },
  },
});

export default patientSlice.reducer;
export const {
  patientValue,
  updateInsurancePolicy,
  updateRulesConfig,
  updateselectedTime,
  patientdetailsValue,
  updateSelectedProvider,
  updateIsExistingPatient,
  removepatientValue,
  updateSessionId,
  updateContentValue,
  updateUTM,
  updatePassedPayLoad,
  updatePageLoader,
} = patientSlice.actions;
